<template>
  <div class="dropzone-wrap">
    <div class="dropzone-uploading" v-if="!uploaded">
      <h3 class="dropzone-categories">
        Пополнить коллекцию картинок <nobr>для
        <select v-model="tag">
          <option v-for="tg in tags" :value="tg.value">{{tg.name_plural}}</option>
        </select>
        </nobr>
      </h3>
      <vue-dropzone v-if="init" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"/>

      <div v-if="refs && refs.length > 0" class="dropzone-send">
        <div class="dropzone-upload">
          <button @click="uploadRefs">Загрузить</button>
        </div>
      </div>
    </div>
    <div class="dropzone-uploaded" v-if="uploaded">
      <p>Картинки будут добавлены в&nbsp;базу после модерации.</p>
      <button @click="uploadMore">Загрузить еще</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';

export default {
  name: 'app',
  components: {
    vueDropzone: vue2Dropzone,
  },
  computed: mapGetters({
    tags: 'tags',
  }),
  data() {
    return {
      refs: [],
      tag: 1,
      init: true,
      uploaded: false,
      dropzoneOptions: {
        acceptedFiles: '.jpg,.jpeg,.png',
        url: '/api/refs/',
        thumbnailWidth: 150,
        thumbnailHeight: 140,
        maxFilesize: 0.5,
        maxFiles: 40,
        accept: (file, done) => {
          this.acceptFiles(file, done);
        },
        dictDefaultMessage: '<p><img class="dropzone-icon" src="/static/add-icon.svg"/></p><p class="dropzone-text">Перетащить одну или несколько картинок</p><p class="dropzone-comment">JPG, PNG, каждый файл не&nbsp;более 500&nbsp;КБ</p>',
        dictFileTooBig: 'Размер файла не должен превышать 500 КБ',
        dictInvalidFileType: 'Файл должен быть в формате JPG, PNG',
      },
    };
  },
  methods: {
    acceptFiles(file) {
      this.refs.push(file);
    },
    uploadRefs() {
      this.uploaded = true;
      for (let ref = 0; ref < this.refs.length; ref += 1) {
        const formData = new FormData();
        formData.append('image', this.refs[ref]);
        formData.append('tags', this.tag);
        this.$store.dispatch('createImage', formData);
      }
      this.refs = [];
    },
    uploadMore() {
      this.uploaded = false;
      this.init = false;
      setTimeout(() => {
        this.init = true;
      }, 200);
    },
  },
};
</script>

<style>
  @keyframes show{
    from{
      opacity: 0;
    }
    to{
      opacity: 1;
    }
  }
  .dropzone{
    &-wrap{
      min-height: 300px;
    }
    &-text{
      color: black;
    }
    &-icon{
      margin-bottom: 6px;
      margin-left: -6px;
    }
    &-upload{
      margin: 20px auto 50px;
      text-align: center;
      width: 100%;
      button{
        display: inline-block;
      }
    }
    &-uploaded{
      p{
        margin-bottom: 30px;
      }
      text-align: center;
      width: 100%;
    }
    &-upload,
    &-uploaded{
      button{
        display: inline-block;
      }
    }
    
    &-uploading,
    &-uploaded{
      animation: show .3s ease-in-out;
    }
    &-send{
      margin-top: 40px;
      select {
        position: relative;
        font-size: 100%;
        margin-left: 2px;
        top: 0px;
      }
    }
    &-categories{
      text-align: center;
      margin-bottom: 25px;
      select{
        text-transform: lowercase;JPG, PNG
        border-bottom: 0;
        margin-left: 2px;
        font-size: 100%;
        top: 0;
        @media (max-width: $mediaMob) {
          background: #fc6315;
          color: white;
        }
      }
    }
    &-comment {
      @media (max-width: $mediaMob) {
        font-size: 80%;
      }
    }
  }

  .vue-dropzone{
    border: 2px dotted #ccc !important;
    border-radius: 200px;
    text-align: center;
    padding: 20px;
  }

  /* Replace standard Dropzone.js styles */

  .dz-preview{
    border-radius: 25px;
    border: solid 1px #ddd;
    max-height: 140px;
    height: 140px;
    width: 150px;
    overflow: hidden;
    
    .dz-details{
      background-color: #fa9920 !important;
      animation: show .3s ease-in-out;
      .dz-size{
        margin-bottom: 3px !important;
      }
    }
  }
  .dz-success-mark,
  .dz-progress{
    display: none;
  }
  .dz-error-message{
    border-radius: 0 !important;
    padding-top: 30px !important;
    font-size: 82% !important;
    position: absolute;
    top: 0 !important;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// Dropzone.vue?70988db6